<template>
  <section class="lms-container">
    <div class="content">
      <div class="breadcrumb" style="border: none !important;"></div>
      <div v-if="questions.length > 0">
        <div
          v-for="question in questions"
          :key="question.id"
          class="message custom-shadow"
          data-id="158"
          style="margin-bottom:15px;"
        >
          <div class="message_wrapper" style>
            <table
              class="message_table footable table table-bordered table-striped table-highlight"
              style="margin:0px;"
            >
              <!-- ------------------------------------ -->
              <!-- DETAIL PRODUCT -->
              <!-- ------------------------------------ -->

              <tbody>
                <tr>
                  <td colspan="2">
                    <strong class="uppercase">{{question.studentName}}</strong> &nbsp;
                    <br />
                    <!-- <span class="color-gray">fabiagondim@gmail.com</span> -->
                  </td>

                  <!-- ------------------------------------ -->
                  <!-- ANSWER BY -->
                  <!-- ------------------------------------ -->
                  <td colspan="2" class="message_answer_by">
                    <div v-if="question.answeredOn != null">
                      <div>
                        <strong>Respondida por: </strong>
                        <span class="fs-small">{{question.teacher}}</span>
                      </div>
                      <div class="fs-small">
                        <i class="icon-time"></i>
                        {{question.answeredOn}}
                      </div>
                    </div>
                    <div v-else>
                      <strong>Não respondida</strong>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div>
                      <strong>Vídeo: </strong>
                      <span class="fs-small">{{question.videoTitle}}</span>
                    </div>
                  </td>
                  <td>
                    <div>
                      <strong>Aula: </strong>
                      <span class="fs-small">{{question.lessonTitle}}</span>
                    </div>
                  </td>
                  <td>
                    <div>
                      <strong>Módulo: </strong>
                      <span class="fs-small">{{question.moduleTitle}}</span>
                    </div>
                  </td>
                  <td>
                    <div>
                      <strong>Curso: </strong>
                      <span class="fs-small">{{question.courseName}}</span>
                    </div>
                  </td>
                </tr>

                <!-- ------------------------------------ -->
                <!-- MESSAGE -->
                <!-- ------------------------------------ -->
                <tr>
                  <td colspan="4">
                    <i class="fs-smaller">Enviado em {{question.createdAt | formatDate}}</i>
                    <br />
                    {{question.text}}
                  </td>
                </tr>

                <!-- ------------------------------------ -->
                <!-- ANSWER -->
                <!-- ------------------------------------ -->
                <tr class="message_answer">
                  <td colspan="5">
                    <div class="flex">
                      <!-- Message -->
                      <div>
                        <textarea
                          @input="changedText($event, question.id)"
                          v-model="question.answer"
                          v-bind:disabled="userType==1"
                          name="answerMessage"
                          style="width:100%"
                          rows="5"
                          id="answerMessage"
                          class="input-large"
                        ></textarea>
                      </div>
                      <lms-button
                        v-if="changedAnswer == question.id"
                        @click="saveAnswer(question.answer , question.id)"
                        :loading="savingAnswer == question.id"
                      >Salvar</lms-button>
                    </div>
                  </td>
                </tr>

                <!-- ------------------------------------ -->
                <!-- ACTIONS -->
                <!-- ------------------------------------ -->
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="placeholder-message">
          <h5>Nenhuma dúvida registrada</h5>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import axios from "axios";

export default {
  data() {
    return {
      changedAnswer: 0,
      savingAnswer: 0,
      savingQuestion: false,
      userType: this.$store.getters.user.type,
      questions: []
    };
  },
  components: {},
  methods: {
    changedText(value, questionId) {
      this.changedAnswer = questionId;
    },
    saveAnswer(answer, questionId) {
      this.savingAnswer = questionId;
      const path = this.$global.endpoint + "/lesson/answer/create";
      axios
        .post(path, {
          answer: {
            text: answer,
            lessonQuestionId: questionId
          }
        })
        .then(res => {
          this.savingAnswer = 0;
          this.changedAnswer = 0;
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Resposta cadastrada com sucesso"
          });
        })
        .catch(error => {
          this.savingAnswer = 0;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    getQuestions() {
      const path = this.$global.endpoint + "/lesson/question/getall";
      axios
        .get(path)
        .then(res => {
          this.questions = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {
    this.getQuestions();
  }
};
</script>
